module.exports = __webpack_public_path__ + "img/User.d19c1274.png";